import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'

/**
 * Top-level entry route for the admin feature.
 *
 * This is registered in `AppModule` BEFORE `AccountRoutingModule`, which has a
 * root `:accountId` matcher that would otherwise catch `/admin` and treat
 * "admin" as an account ID. Order in `AppModule.imports` is what disambiguates.
 */
const routes: Routes = [
  {
    path: 'admin',
    loadChildren: () => import('./admin.module').then((m) => m.AdminModule),
  },
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AdminEntryRoutingModule {}
